module.exports = __webpack_public_path__ + "media/images/new_landing/hp/forAgencies-f6996144481d844fab02a307aa4e9a8f.jpg";